<template>
    <div class="banner-css media-centre-css">
        <div class="file-manager-actions">
        	<div class="w-100">
        	  	<button type="button" class="btn btn-primary mr-2" data-toggle="modal" data-target="#upload"><i class="ion ion-md-cloud-upload"></i>&nbsp; Upload</button>
        	  	<div class="btn-group mr-2">
        	    	<button type="button" class="btn btn-danger" :class="{'disabled': (banner_array < 1)}" @click="delete_banner()"><i class="far fa-trash-alt"></i>&nbsp; Delete</button>
        	  	</div>
                <div class="btn-group mr-2" v-if="query_strings.archive == 0">
                    <button type="button" class="btn btn-warning" :class="{'disabled': (banner_array < 1)}" @click="archive_banner()"><i class="fas fa-folder-minus"></i>&nbsp; Archive</button>
                </div>
                <div class="btn-group mr-2" v-else>
                    <button type="button" class="btn btn-warning" :class="{'disabled': (banner_array < 1)}" @click="archive_banner()"><i class="fas fa-folder"></i>&nbsp; Unarchive</button>
                </div>
                <div class="ml-auto">                             
                    <div class="input-group position-relative">
                        <input type="text" v-model="query_strings.search" @change="get_query()" class="form-control" placeholder="Search Banners"/>
                        <div class="input-group-append">
                            <div class="input-group-text"><i class="fas fa-search"></i></div>
                        </div>
                        <i class="fas fa-times-circle position-absolute clear-input" v-if="query_strings.search" @click="query_strings.search = '', get_query()"></i>
                    </div>
                </div>
        	</div>
        </div>

        <hr class="mt-3">

        <div v-if="banners.length > 0">

            <div>
                <a href="#" @click.prevent="query_strings.archive = 1, get_query()" v-if="query_strings.archive == 0">View Archives</a>
                <a href="#" @click.prevent="query_strings.archive = 0, get_query()" v-else>View Banners</a>
            </div>

            <p>
                Click on names, alt text to edit it.
            </p>

            <div class="file-manager-container file-manager-col-view mt-3">

                <div class="file-item" v-for="banner in banners">
                    <div class="file-item-select-bg bg-primary"></div>
                    <div class="d-flex w-100 align-items-center">
                        <label class="custom-control custom-checkbox">
                          	<input type="checkbox" class="custom-control-input" :value="banner.id" v-model="banner_array">
                          	<span class="custom-control-label"></span>
                        </label>
                        <a href="#" class="far fas fa-folder-minus ml-auto text-info" @click.prevent="archive_banner('single', banner.id)" v-if="query_strings.archive == 0" title="Archive"></a>
                        <a href="#" class="far fas fa-folder ml-auto text-info" @click.prevent="archive_banner('single', banner.id)" title="Unarchive" v-else></a>
                        <a href="#" class="far fa-trash-alt ml-2 text-danger" @click.prevent="delete_banner('single', banner.id)" title="Delete"></a>
                    </div>                
                    <div class="mt-2"> 
                        <img :src="banner.sizes.desktop.jpg" class="img-fluid" />            
                    </div>
                    <div class="mt-2">
                        <img :src="banner.sizes.mobile.jpg" class="img-fluid" />            
                    </div>
                    <div class="mt-2 text-left d-flex w-100 align-items-center">
                        <div class="input-text">
                            Banner Name:
                        </div>
                        <input class="focus-input w-100" v-model="banner.name" @change="update_banner(banner.id, banner.name, banner.alt)" placeholder="Enter banner name" />
                    </div>
                    <div class="mt-2 text-left d-flex w-100 align-items-center">
                        <div class="input-text">
                            Banner alt/title:
                        </div>
                        <input class="focus-input w-100" v-model="banner.alt" @change="update_banner(banner.id, banner.name, banner.alt)" placeholder="Enter alt/title text" />
                    </div>

                </div>

            </div>

            <nav>
                <ul class="pagination flex-wrap">
                    <li class="page-item" v-for="page in page_info.last_page" v-if="page_info.last_page != 1" :class="{'active': (page == query_strings.page)}">
                        <a class="page-link" v-if="page == query_strings.page">{{page}}</a>
                        <a class="page-link" @click.prevent="query_strings.page = page, get_query()" href="#" v-else>{{page}}</a>
                    </li>
                </ul>
            </nav>

        </div>

        <div class="text-center mt-5" v-else-if="!loading">
            No results founds matching your query. <a href="#" @click.prevent="query_strings.page = 1, query_strings.archive = 0, query_strings.search = '', get_query()">Reset</a>
        </div>

        <div class="modal fade" id="upload" tabindex="-1" role="dialog" aria-labelledby="upload modal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Upload banner</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="banner">Banner Name*</label>
                            <input type="text" class="form-control" id="banner" placeholder="Banner Name" v-model="banner_file.name">
                        </div>
                        <div class="form-group">
                            <label for="banner_alt">Banner Alt/Title</label>
                            <input type="text" class="form-control" id="banner_alt" placeholder="Banner Alt/Title" v-model="banner_file.alt">
                        </div>
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="desktopfile" @change="add_desktop" accept=".png, .jpg">
                            <label class="custom-file-label" for="desktopfile" v-if="!banner_file.desktop.name">Choose desktop banner*</label>
                            <label class="custom-file-label" for="desktopfile" v-else>{{banner_file.desktop.name}}</label>
                        </div>
                        <div class="custom-file mt-3">
                            <input type="file" class="custom-file-input" id="mobilefile" @change="add_mobile" accept=".png, .jpg">
                            <label class="custom-file-label" for="mobilefile" v-if="!banner_file.mobile.name">Choose mobile banner*</label>
                            <label class="custom-file-label" for="mobilefile" v-else>{{banner_file.mobile.name}}</label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" :class="{'disabled': (banner_file.name.length < 1 || !banner_file.desktop.name || !banner_file.mobile.name)}" @click="upload_banner">
                            Upload
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <loader :loading="loading"></loader>

    </div>
</template>

<script>

import loader from './loader.vue';

export default {
    components: {
        loader,
    },

    data() {
        return {
            banners: [],
            page_info: [],
            query_strings: {
                page: 1,
                archive: 0,
                search: ''
            },

            banner_file: {
                name: '',
                alt: '',
                desktop: false,
                mobile: false,
            },

            banner_array: [],

            loading: true,
        };
    },

    props: {
    },

    mounted(){
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('page')){
            this.query_strings.page = urlParams.get('page');
        }
        if(urlParams.get('archive')){
            this.query_strings.archive = urlParams.get('archive');
        }
        if(urlParams.get('search')){
            this.query_strings.search = urlParams.get('search');
        }

        this.get_banners();
    },

    methods: {
        get_banners: function(){
            this.loading = true;
            axios.get('/media-centre/banners/list',{
                params: {
                    page: this.query_strings.page,
                    archive: this.query_strings.archive,
                    search: this.query_strings.search,
                }
            })
            .then(function (response) {
                this.page_info = response.data.banners;
                this.banners = response.data.banners.data;
                this.loading = false;
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
                this.loading = false;
            })
        },

        add_desktop: function(e){
            this.banner_file.desktop = e.target.files[0];
        },

        add_mobile: function(e){
            this.banner_file.mobile = e.target.files[0];
        },

        upload_banner: function(){
            let data = new FormData();

            data.append('name', this.banner_file.name);
            data.append('alt', this.banner_file.alt);
            data.append('desktop', this.banner_file.desktop, this.banner_file.desktop.name);
            data.append('mobile', this.banner_file.mobile, this.banner_file.mobile.name);            

            axios.post('/media-centre/banners', data, {
                headers: {
                    'content-type': 'multipart/form-data',
                },
            })
            .then(function (response) {
                this.get_banners();
                this.banner_file.name = '';
                this.banner_file.alt = '';
                this.banner_file.desktop = false;
                this.banner_file.mobile = false;

                document.getElementById("desktopfile").value = "";
                document.getElementById("mobilefile").value = "";

            }.bind(this))
            .catch(function (error) {
                alert(error);
                this.get_banners();
            }.bind(this))
        },

        update_banner: function(id, banner_name, banner_alt){
            axios.patch('/media-centre/banners/' + id,{
                name: banner_name,
                alt: banner_alt,
            })
            .then(function (response) {
                this.get_banners();
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error.response.data.errors.name[0]);
                this.get_banners();
            }.bind(this))
        },

        delete_banner: function(single, id){
            if(single){
                this.banner_array = [id];
            }
            axios.delete('/media-centre/banners', {
                data: {
                    id: this.banner_array,
                }
            })
            .then(function (response) {
                this.get_banners();
                this.banner_array = [];
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error.response.data.errors.id[0]);
                this.get_banners();
            }.bind(this))
        },

        archive_banner: function(single, id){
            if(single){
                this.banner_array = [id];
            }
            axios.patch('/media-centre/banners/archive', {
                id: this.banner_array,                
            })
            .then(function (response) {
                this.get_banners();
                this.banner_array = [];
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error.response.data.errors.id[0]);
                this.get_banners();
            }.bind(this))
        },

        get_query: function(){
            let queryString = '';
            if(this.query_strings.page > 1){
                queryString += 'page=' + this.query_strings.page + '&';
            }
            if(this.query_strings.archive > 0){
                queryString += 'archive=' + this.query_strings.archive + '&';
            }
            if(this.query_strings.search.length > 0){
                queryString += 'search=' + this.query_strings.search + '&';
            }
            if(queryString.length > 0 ){
                queryString = '?' + queryString;
                queryString = queryString.substring(0, queryString.length - 1);

            }
            history.pushState({page: 0}, "", window.location.pathname + queryString);

            this.get_banners();
        },
    },
};
</script>